module.exports = __webpack_public_path__ + "img/cast_ic_international.64a56ec3.svg";